import { c as _c } from "react/compiler-runtime";
import { Typography, Stack } from '@mui/material';
import type { BackupPolicyType, ResourceType } from '@repo/api-gw-sdk';
import Image, { type StaticImageData } from 'next/image';
import type { ReactNode } from 'react';
import { ResourceTypes } from '@/data/inventory/resourceTypes';
import AllExcluded from '../../../../../../../public/statics/images/illustrations/resource-selection/all_excluded.png';
import AllIncluded from '../../../../../../../public/statics/images/illustrations/resource-selection/all_included.png';
import { isPitrPolicyType } from '../../backupPoliciesTypes';
const DynamicResourcesEmptyState = t0 => {
  const $ = _c(23);
  const {
    title,
    description,
    illustration,
    alt,
    size
  } = t0;
  const t1 = size === "small" ? "24px" : "40px";
  const t2 = size === "small" ? "320px" : "480px";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      gap: t1,
      marginX: "40px",
      alignItems: "center",
      width: t2,
      alignSelf: "center",
      justifySelf: "center"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = size === "small" ? 60 : 240;
  const t5 = size === "small" ? 60 : 240;
  let t6;
  if ($[3] !== alt || $[4] !== illustration || $[5] !== t4 || $[6] !== t5) {
    t6 = <Image alt={alt} height={t4} width={t5} src={illustration} />;
    $[3] = alt;
    $[4] = illustration;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = size === "small" ? "8px" : "12px";
  let t8;
  if ($[8] !== t7) {
    t8 = {
      gap: t7,
      alignItems: "center"
    };
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== size || $[11] !== title) {
    t9 = typeof title === "string" ? <Typography variant={size === "small" ? "subtitle1" : "h3"}>{title}</Typography> : title;
    $[10] = size;
    $[11] = title;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== description) {
    t10 = description && <Typography variant="body1" sx={{
      textAlign: "center",
      width: "320px"
    }}>{description}</Typography>;
    $[13] = description;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t8 || $[17] !== t9) {
    t11 = <Stack sx={t8}>{t9}{t10}</Stack>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t3 || $[21] !== t6) {
    t12 = <Stack sx={t3}>{t6}{t11}</Stack>;
    $[19] = t11;
    $[20] = t3;
    $[21] = t6;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
export const DynamicResourcesAllIncluded = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    description,
    selectedResourceTypes,
    policyType
  } = t0;
  const size = t1 === undefined ? "large" : t1;
  let t2;
  if ($[0] !== policyType || $[1] !== selectedResourceTypes) {
    t2 = selectedResourceTypes && isPitrPolicyType(policyType) ? selectedResourceTypes?.map(_temp).join(", ") : "";
    $[0] = policyType;
    $[1] = selectedResourceTypes;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `All ${t2} resources are included`;
  let t4;
  if ($[3] !== description || $[4] !== size || $[5] !== t3) {
    t4 = <DynamicResourcesEmptyState title={t3} alt="All resources are included" description={description} illustration={AllIncluded} size={size} />;
    $[3] = description;
    $[4] = size;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const DynamicResourcesAllExcluded = t0 => {
  const $ = _c(3);
  const {
    size: t1,
    description
  } = t0;
  const size = t1 === undefined ? "large" : t1;
  let t2;
  if ($[0] !== description || $[1] !== size) {
    t2 = <DynamicResourcesEmptyState title="All resources are excluded" alt="All resources are excluded" description={description} illustration={AllExcluded} size={size} />;
    $[0] = description;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(type) {
  return ResourceTypes[type].displayName;
}